import React from 'react'

const BlogContainer = ({ children }) => {
    return <div className='container mx-auto '>{children}</div>
}

export default BlogContainer
